const info = (...params: any[]) => {
  // eslint-disable-next-line no-console
  console.info(params);
};
const warn = (...params: any[]) => {
  // eslint-disable-next-line no-console
  console.warn(params);
};
const error = (...params: any[]) => {
  // eslint-disable-next-line no-console
  console.error(params);
};

export const log = {
  info,
  warn,
  error,
};
